import {
  HttpErrorResponse, HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { LoginPage } from '../../pages/auth/login/login';
import { App } from 'ionic-angular';
import { User } from '../models/security.models';
import { cloneDeep } from 'lodash';
import {VesselContextService} from "../../services/vessel/vessel-context.service";
import {ClientInstanceService} from '../../services/signalR/client-instance.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService: AuthService;
  private vesselContext: VesselContextService;
  private clientInstance: ClientInstanceService;

  constructor(
    private router: Router,
    private injector: Injector,
    public app: App,
  ) {
    this.authService = injector.get(AuthService);
    this.vesselContext = injector.get(VesselContextService);
    this.clientInstance = injector.get(ClientInstanceService);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers: any = {
      Authorization: this.authService.getAuthHeader(),
      'X-Client-Instance-Id': this.clientInstance.id,
    };

    const vesselId = this.vesselContext.getVesselId();
    if (vesselId) {
      headers['X-Vessel-Id'] = String(vesselId);
    }

    req = req.clone({ setHeaders: headers });

    return next.handle(req).pipe(tap(() => {}, event => {
      if (event instanceof HttpErrorResponse) {
        if (event.status === 401 || event.status === 403) {
          if (this.authService.isAuthenticated) {
            const userId = cloneDeep(this.authService.currentUser<User>().id);
            this.authService.logout();
            this.app.getActiveNav().parent.push(LoginPage, { sessionTimeout: true, previousUser: userId });
          }
        }
      }
    }));
  }
}



// WEBPACK FOOTER //
// ./src/_foundation/utils/auth.interceptor.ts